export const base = '/';

const routeCodes = {
  LOGIN: `${base}login`,
  CREATE_ACCOUNT: `${base}create-account`,
  EMAIL_SENT: `${base}email-sent`,
  FORGOT_PASSWORD: `${base}forgot-password`,
  RESET_PASSWORD: `${base}reset-password`,
  CREATE_PASSWORD: `${base}create-password`,
  ABOUT: `${base}about`,
  TERMS: `${base}terms`,
  ENDUSER: `${base}end-user-agreement`,
  PRIVACY: `${base}privacy`,
  ADMIN: `${base}admin/`,
  SUPER_ADMIN: `${base}super-admin/`,
  OPS: `${base}ops/`,
  GROUP_LEADER: `${base}group-leader/`,
  ROOT: base
};

// eslint-disable-next-line
const { ADMIN, ROOT, OPS, SUPER_ADMIN, GROUP_LEADER } = routeCodes;
export const subRouteCodes = {
  RENTER: {
    CREATE_ORDER: [
      `${ROOT}reservation/:eventId/checkout`,
      `${ROOT}reservation/:eventId/rvs`,
      `${ROOT}reservation/:eventId`,
      `${ROOT}reservation/:eventId/stalls`
    ],
    CONFIRM_RESERVATION: `${ROOT}reservation/confirmation/:orderId`,
    EVENTS: `${ROOT}events`,
    RESERVATIONS: `${ROOT}reservations`,
    CARDS: `${ROOT}saved-cards`,
    HELP: `${ROOT}help`,
    VIEW_RESERVATION: `${ROOT}reservation/details/:orderId`
  },
  ADMIN: {
    EVENTS: `${ADMIN}events`,
    CREATE_EVENT: `${ADMIN}events/new`,
    EDIT_EVENT: `${ADMIN}events/edit/:eventId`,
    ORDERS: `${ADMIN}orders`,
    CREATE_ORDER: `${ADMIN}order/new`,
    EDIT_ORDER: `${ADMIN}order/edit/:orderId`,
    GROUPS: `${ADMIN}groups`,
    REPORTS: `${ADMIN}reports`,
    USERS: `${ADMIN}users`,
    PUSH_DEMO: `${base}push-notifications-demo`,
    MAPS: `${ADMIN}maps`,
    SETTINGS: `${ADMIN}settings`,
    DASHBOARD: `${ADMIN}dashboard`,
    DISCOUNT_CODES: `${ADMIN}discount-codes`,
    DISCOUNT_CODES_CREATE: `${ADMIN}discount-codes/new`
  },
  OPS: {
    STALLS: `${OPS}stalls`,
    RVS: `${OPS}rvs`
  },
  SUPER_ADMIN: {
    CREATE_VENUE: `${SUPER_ADMIN}venues/new`,
    MAIN: `${SUPER_ADMIN}`,
    VENUES: `${SUPER_ADMIN}venues`,
    MAPS: `${SUPER_ADMIN}maps`,
    MAPS_CREATE: `${SUPER_ADMIN}maps/new`,
    MAPS_EDIT: `${SUPER_ADMIN}maps/edit`,
    BUILDINGS: `${SUPER_ADMIN}buildings`,
    BUILDING_CREATE: `${SUPER_ADMIN}building/new`,
    ADDONS: `${SUPER_ADMIN}addons`,
    ADDONS_CREATE: `${SUPER_ADMIN}addons/new`,
    STALLS: `${SUPER_ADMIN}stalls`,
    STALLS_CREATE: `${SUPER_ADMIN}stalls/new`,
    STALLS_DELETE: `${SUPER_ADMIN}stalls/delete`,
    RVLOTS: `${SUPER_ADMIN}rvlots`,
    RVLOTS_CREATE: `${SUPER_ADMIN}rvlots/new`,
    RVSPOTS: `${SUPER_ADMIN}rvspots`,
    RVSPOTS_CREATE: `${SUPER_ADMIN}rvspots/new`,
    USERS: `${SUPER_ADMIN}users`,
    USER_CREATE: `${SUPER_ADMIN}users/new`,
    VENUES_EVENTS: `${SUPER_ADMIN}venues-information`,
    EVENT_HISTORY: `${SUPER_ADMIN}event-history`,
    ADMIN_ORDER_HISTORY: `${SUPER_ADMIN}admin-order-history`,
    ORDER: `${SUPER_ADMIN}order`,
    EVENT_PRODUCTS: `${SUPER_ADMIN}event-products`,
    DISCOUNT_CODES: `${SUPER_ADMIN}discount-codes`,
    DISCOUNT_CODES_CREATE: `${SUPER_ADMIN}discount-codes/new`
  },
  GROUP_LEADER: {
    ORDERS: `${GROUP_LEADER}orders`,
    GROUPS: `${GROUP_LEADER}groups`,
    CREATE_ORDER: `${GROUP_LEADER}order/new`,
    EDIT_ORDER: `${GROUP_LEADER}order/edit/:orderId`
  }
};

export default routeCodes;
